import { Grid, Typography, Box, Button, TextField } from '@mui/material'
import { useFormContext, useFieldArray ,Controller} from 'react-hook-form'
import { ICarrier } from '@/types'
const PowerUnits = () => {
    const form = useFormContext<ICarrier>();
   const { fields: powerunitFields, append: appendPowerunit, remove: removePowerunit } = useFieldArray({
      control: form.control,
      name: 'powerunit' as any,
    });

    const { fields: trailerFields, append: appendTrailer, remove: removeTrailer } = useFieldArray({
      control: form.control,
      name: 'trailer' as any,
    });
  return (
    <Grid container spacing={1}>
    <Grid item xs={12} md={6}>
      <Typography sx={{mb:1.5}} fontSize={14}>Power Units</Typography>
      {powerunitFields.map((field, index) => (
        <Box key={field.id} display="flex" gap={1} alignItems="center" mb={2.2}>
          <Controller
            name={`powerunit.${index}`}
            control={form.control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                label={`Power Unit ${index + 1}`}
                InputLabelProps={{ shrink: true }}
                size='small'
              />
            )}
          />
          <Button onClick={() => removePowerunit(index)} color="error" sx={{fontSize:'0.8rem', fontWeight:'600'}}>Remove</Button>
        </Box>
      ))}
      <Button variant="outlined" onClick={() => appendPowerunit('')}
        sx={{
            borderRadius:0.5,
            py:0.5,
            fontSize:'0.8rem',
            pr:2,
            pl:1.5,
            '& .MuiButton-startIcon': {
                  marginRight: '3px',
                  },
          }}
        >
        <strong>+ Add Power Unit</strong></Button>
    </Grid>

    <Grid item xs={12} md={6}>
      <Typography fontSize={14} sx={{mb:1.5}}>Trailers</Typography>
      {trailerFields.map((field, index) => (
        <Box key={field.id} display="flex" gap={1} alignItems="center" mb={2.2}>
          <Controller
            name={`trailer.${index}`}
            control={form.control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                label={`Trailer ${index + 1}`}
                InputLabelProps={{ shrink: true }}
                size='small'
              />
            )}
          />
          <Button onClick={() => removeTrailer(index)} color="error" sx={{fontSize:'0.8rem', fontWeight:'600'}}>Remove</Button>
        </Box>
      ))}
      <Button variant="outlined" onClick={() => appendTrailer('')}
        sx={{
            borderRadius:0.5,
            py:0.5,
            fontSize:'0.8rem',
            pr:2,
            pl:1.5,
            '& .MuiButton-startIcon': {
                  marginRight: '3px',
                  },
          }}
        >
        <strong>+ Add Trailer</strong>
        </Button>
    </Grid>

  </Grid>
  )
}

export default PowerUnits